import { Icon } from '@easy-expense/ui-shared-components';
import { Layout, OpenSans, Spacer } from '@easy-expense/ui-web-core';
import React from 'react';

import { ZoomableImage } from './ZoomableImage.component';

export const ReceiptContent: React.FC<{
  loadError: boolean;
  receiptURI: string;
  onError: () => void;
}> = ({ loadError, receiptURI, onError }) => {
  if (loadError) {
    return (
      <Layout.Column center>
        <Icon name="alert-circle-outline" size={48} iconColor="gray" />
        <Spacer.Vertical size={12} />
        <OpenSans.Secondary>Unable to load receipt</OpenSans.Secondary>
      </Layout.Column>
    );
  }

  return <ZoomableImage uri={receiptURI} onError={onError} />;
};
